import { defineStore } from "pinia";

import { Toast } from "vant";

let toast: ReturnType<typeof Toast>;

const showToast = (options: ToastOptions) => {
  toast = Toast(options);
};

const closeToast = () => {
  toast?.clear();
};

import type { ToastOptions } from "vant";
import "vant/es/toast/style";

import { noop } from "@ht/utils";
import { isInHelloTalk } from "ht-tool";

const isInHT = isInHelloTalk();
export interface LoadingToastState {
  loadingToast: boolean;
  disabled?: boolean;
  // loadingToastQueue: Array<typeof showToast>;
  timer: ReturnType<typeof setTimeout> | number;
}

type LoadingToastOptions = ToastOptions & { delayTime?: number };

const defaultLoadingToastOptions: LoadingToastOptions = {
  type: "loading",
  position: "middle",
  message: "",
  // wordBreak: "break-word",
  iconSize: "20px",
  overlay: false,
  forbidClick: true,
  closeOnClick: false,
  closeOnClickOverlay: false,
  loadingType: "spinner",
  duration: 0,
  teleport: "body",
  onClose: noop,
  onOpened: noop,
  delayTime: 0
};

const defaultFailToastOptions: ToastOptions = {
  type: "fail",
  position: "middle",
  message: "",
  // wordBreak: "break-word",
  overlay: false,
  forbidClick: true,
  closeOnClick: false,
  closeOnClickOverlay: false,
  loadingType: "spinner",
  duration: 2000,
  teleport: "body",
  onClose: noop,
  onOpened: noop
};

// 切换页面关闭loading、取消请求
// 多个loading队列展示
export const useLoadingToastStore = defineStore("loading-toast", {
  state: (): LoadingToastState => ({
    loadingToast: false,
    // loadingToastQueue: [],
    disabled: false,
    timer: 0
  }),
  actions: {
    setShowLoadingToast(options?: LoadingToastOptions) {
      if (this.disabled) return;
      const mergeOptions = Object.assign(
        {},
        defaultLoadingToastOptions,
        options
      );
      if (options?.delayTime) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          showToast(mergeOptions);
        }, options?.delayTime);
      } else {
        showToast(mergeOptions);
      }
    },

    closeLoadingToast() {
      if (this.disabled) return;
      clearTimeout(this.timer);
      this.timer = 0;
      closeToast();
    },

    showToastFail() {
      if (this.disabled) return;
      if (!isInHT) return;
      showToast(defaultFailToastOptions);
    }
  }
});

export const setDefaultFailToastOptions = (options: Partial<ToastOptions>) => {
  Object.assign(defaultFailToastOptions, options);
};
